import { Menu } from 'lucide-react'
import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { TickerSearch } from '@/components/ticker/ticker-search'
import { useMobileWorkspace } from '@/workspace'

interface TopBarProps {
  onMenuClick: () => void
}

/**
 * Mobile-only top bar with menu toggle.
 * Desktop uses the persistent sidebar instead.
 */
export function TopBar({ onMenuClick }: TopBarProps) {
  const mobileWs = useMobileWorkspace()

  return (
    <header className="flex h-10 items-center gap-2 text-sidebar-foreground px-3 md:hidden">
      {/* Logo — left; clicking returns to the dashboard */}
      <Link
        to="/dashboard"
        aria-label="Go to dashboard"
        className="flex items-center rounded outline-none focus-visible:ring-2 focus-visible:ring-sidebar-foreground/40 shrink-0"
      >
        <img src="/static/EdgeToTradeWhiteText.svg" alt="Edge to Trade" className="h-5 w-auto" />
      </Link>

      {/* Search — center, fills available space */}
      {mobileWs ? (
        <div className="flex-1 min-w-0 max-w-[65%] mx-auto">
          <TickerSearch
            variant="full"
            onSelect={(symbol) => mobileWs.selectTicker(symbol)}
            placeholder="Ticker"
            // 12px to match the ticker field everywhere else (the `full` variant
            // defaults to 14px, which read too large in the top bar).
            className="w-full text-[12px]"
          />
        </div>
      ) : (
        <div className="flex-1" />
      )}

      {/* Hamburger menu — right */}
      <Button variant="ghost" size="icon" className="h-8 w-8 shrink-0" onClick={onMenuClick}>
        <Menu className="h-5 w-5" />
      </Button>
    </header>
  )
}
